/**
 * Compute open/lunch-break status from the standard business.hours dict.
 *
 * Return values:
 *   { state: "open" }
 *   { state: "lunch_break",  reopensAt: "14:00" }   // closed between slot 1 and slot 2 today
 *   { state: "closed_today_opens_later", reopensAt: "09:00" }  // still before first slot today
 *   { state: "closed" }
 *   null → no hours configured, don't render any status
 *
 * Format supported (same as HoursEditor):
 *   "HH:MM-HH:MM"                    → 1 continuous range
 *   "HH:MM-HH:MM,HH:MM-HH:MM"        → 2 ranges (morning + afternoon)
 *   "closed" / ""                    → closed / not set
 */
const DAY_KEYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

function parseRangesRaw(v) {
  if (!v || v === "closed") return [];
  return String(v).split(",").map((p) => {
    const [o, c] = (p || "").split("-");
    if (!o || !c) return null;
    return { open: o, close: c };
  }).filter(Boolean);
}

function toMin(s) {
  const [h, m] = s.split(":").map(Number);
  return h * 60 + (m || 0);
}

export function getOpenStatus(hours, now = new Date()) {
  if (!hours || typeof hours !== "object") return null;
  const todayIdx = (now.getDay() + 6) % 7; // Mon=0
  const todayKey = DAY_KEYS[todayIdx];
  const ranges = parseRangesRaw(hours[todayKey]);
  if (ranges.length === 0) return null; // nothing to say
  const nowMin = now.getHours() * 60 + now.getMinutes();

  // In any range → open
  for (const r of ranges) {
    if (nowMin >= toMin(r.open) && nowMin <= toMin(r.close)) {
      return { state: "open" };
    }
  }
  // Before first range → will open later today
  if (nowMin < toMin(ranges[0].open)) {
    return { state: "closed_today_opens_later", reopensAt: ranges[0].open };
  }
  // Between two ranges → lunch break, will reopen for slot 2
  if (ranges.length >= 2 && nowMin > toMin(ranges[0].close) && nowMin < toMin(ranges[1].open)) {
    return { state: "lunch_break", reopensAt: ranges[1].open };
  }
  // After last range → done for the day
  return { state: "closed" };
}
